<template>
  <div class="wrap">
    <div class="caption">
      蔵衛門IDのパスワードを再設定しました。
    </div>
    <div class="btn-wrap">
      <button class="btn to-login-btn"
              @click="$router.replace({ name: 'login' })">
        ログイン画面へ
      </button>
    </div>    
  </div>

</template>

<script>
export default {
  name: 'Complete'
}
</script>

<style scoped>
.wrap {
  width: 500px;
  margin: auto;
  padding: 1rem;
  text-align: center;
}
.caption {
  font-size: 1.4rem;
  font-weight: bold;
  margin: 4rem 0 2rem 0;
  text-align: center;
}
.btn-wrap {
  text-align: center;
}
.btn {
  border: none;
  border-radius: 0.5rem;
  cursor: pointer;
  font-size: 1rem;
  padding: 0.5rem;
  width: 17rem;
}
.to-login-btn {
  background-color: #333;
  color: white;
}
@media (max-width: 1024px) {
  .wrap {
    max-width: 500px;
    width: 80%;
  }
}
</style>